import React from 'react'
import {ReactComponent as NoDataIcon} from '../../assets/Icons/NoData.svg'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../Translation/English/global'

export const NoData: React.FC = () => {
  const wt = useWt()

  return (
    <div className={'no-data-content'}>
      <NoDataIcon />
      <p> {wt(GLOBAL.noData)}</p>
    </div>
  )
}
